import React from 'react';
import { Toaster } from 'sonner';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Experience } from './components/Experience';
import { Skills } from './components/Skills';
import { BoardPositioning } from './components/BoardPositioning';
import { ImpactMetrics } from './components/ImpactMetrics';
import { StrategicFramework } from './components/StrategicFramework';
import { CareerTrackRecord } from './components/CareerTrackRecord';
import { TechnicalMastery } from './components/TechnicalMastery';
import { BoardEducation } from './components/BoardEducation';
import { ContactPortal } from './components/ContactPortal';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-slate-50 font-sans" data-id="element-0" data-mp="28tmfb3zlmcxr">
      <Navbar data-id="element-1" data-mp="28s2ztflro5x1" />
      <main data-id="element-2" data-mp="23vkvuhy9gblr">
        <Hero data-id="element-3" data-mp="23vupcfiil0w7" />
        <About data-id="element-4" data-mp="23u9uspw79hyc" />
        <Experience data-id="element-5" data-mp="23utbk3a460as" />
        <Skills data-id="element-6" data-mp="23t8g8bfz6dbv" />
        <BoardPositioning data-id="element-7" data-mp="3ijxnsm94vshs" />
        <ImpactMetrics data-id="element-8" data-mp="3ikr0e3urxc7u" />
        <StrategicFramework data-id="element-9" data-mp="3ij61k21ff746" />
        <CareerTrackRecord data-id="element-10" data-mp="3ii4t85bsoyq5" />
        <TechnicalMastery data-id="element-11" data-mp="3ml14tc2x3ukl" />
        <BoardEducation data-id="element-12" data-mp="3mkhofzsx1e8o" />
        <ContactPortal data-id="element-13" data-mp="3mjq3rk0ux0x6" />
      </main>
      <Footer data-id="element-14" data-mp="3rcj7q5oi4587" />
      <Toaster position="bottom-right" richColors data-id="element-15" data-mp="3rbzmog3k10py" />
    </div>;
}